module.exports = __webpack_public_path__ + "static/media/1009798.98ae22ae.jpg";